const topics = [
  
  {
    title: "Place Value",
    slug: "placevalue",
    standardNumber: "2.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplacevalue2025video.mp4?alt=media&token=3f9c9c42-f584-47e7-bcdd-b83c8aa7fbbc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplacevalue2025song.mp3?alt=media&token=847038d3-72ea-4c54-9645-9ef01971073e",
    lyrics: ["(intro)",
"Place value.",
"Place value.",

"(chorus)",
"As we go to the left,",
"each place value goes up 10 times.",
"As we go to the left,",
"each place value goes up 10 times.",

"(verse)",
"In our number system",
"the value depends on the place or position",
"of a number, of a number.",
"In our number system",
"the value depends on the place or position",
"of a number, of a number.",

"Ones place.",
"Tens place.",
"Hundreds place.",
"Thousands place.",
"Ten thousands place.",
"Hundred thousands place.",
"Millions place.",

"Ones place.",
"Tens place.",
"Hundreds place.",
"Thousands place.",
"Ten thousands place.",
"Hundred thousands place.",
"Millions place.",

"(chorus)",
"As we go to the left,",
"each place value goes up 10 times.",
"As we go to the left,",
"each place value goes up 10 times.",

"(outro)",
"Place value.",
"Place value.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Greater Than",
    slug: "greaterthan",
    standardNumber: "2.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgreaterthan2025video.mp4?alt=media&token=5f83b245-64f5-4996-8ce7-007211772077",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgreaterthanlessthan2025song.mp3?alt=media&token=680d1faa-4910-4495-9fe2-dcde359b0bd5",
    lyrics: ["(Chorus)",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",

"(Verse)",
"The greater than and less than symbol, let’s call it an alligator.",
"An alligator that’s hungry and he only eat numbers that’s greater.",
"When his mouth is open it faces the larger number.",
"So, the closed side is less than and the open side is greater.",
"If there’s an equal sign between two numbers, then they’re equal.",
"If there’s an equal sign between two numbers, then they’re equal.",

"(Chorus)",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Count By 5's",
    slug: "countby5s",
    standardNumber: "2.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcountby52025videonew.mp4?alt=media&token=c06a5a39-013a-4537-bc7c-016af5c33b63",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcountyby5-2025song-new.mp3?alt=media&token=79adaa27-41c9-4d84-a684-1a9efdf2e4dd",
    lyrics: ["[chorus]",
"5, 10, 15, 20,",
"25, 30, 35, 40,",
"45, 50, 55, 60,",
"65, 70, 75, 80,",
"85, 90, 95, 100.",
"[verse]",
"Let's start with 5, it's lots of fun,",
"counting by fives, one by one.",
"5, 10, 15, 20,",
"these numbers come up plenty!",
"25, 30, here we go,",
"counting by fives helps you grow.",
"35, 40, now we're moving,",
"look how our numbers keep improving!",
"45, 50, halfway there,",
"counting by fives, with time to spare.",
"55, 60, watch us thrive,",
"learning together, high-five!",
"65, 70, almost done,",
"counting by fives is so much fun!",
"75, 80, moving along,",
"join in the count, sing the song!",
"85, 90, nearly through,",
"counting by fives is great for you!",
"95, 100, we did arrive,",
"thanks for counting, high-five!",
"[chorus]",
"5, 10, 15, 20,",
"25, 30, 35, 40,",
"45, 50, 55, 60,",
"65, 70, 75, 80,",
"85, 90, 95, 100.",
"© Smart Board Learning, LLC. All rights reserved."]
  },
  {
    title: "Count By 10's",
    slug: "countby10s",
    standardNumber: "2.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcountby10-2025video.mp4?alt=media&token=6d16fd34-0e41-4931-80bf-2624e2ffde3a",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcountby10-2025song.mp3?alt=media&token=76e47a42-9e1f-4c86-85a8-b3fc8b0f8a98",
    lyrics: ["(chorus)",
"10, 20, 30, 40,",
"50, 60, 70, 80,",
"90, 100.",
"10, 20, 30, 40,",
"50, 60, 70, 80,",
"90, 100.",
"(verse)",
"Let’s start with 10, it’s easy to do,",
"counting by tens, just me and you.",
"10, 20, 30, 40,",
"counting by tens, let’s get sporty!",
"50, 60, 70, 80,",
"keep it up, we'll do it greatly.",
"90, 100, counting by tens.",
"we can count by tens, let's do it again!",
"(chorus)",
"10, 20, 30, 40,",
"50, 60, 70, 80,",
"90, 100.",
"10, 20, 30, 40,",
"50, 60, 70, 80,",
"90, 100.",
"© Smart Board Learning, LLC. All rights reserved."]
  },
  {
    title: "Ordinal Numbers",
    slug: "ordinalnumbers",
    standardNumber: "2.3",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fordinalnumbers.mp4?alt=media&token=24923b97-658e-416b-ab71-df6890150945",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fordinalnumbers2025song.mp3?alt=media&token=7e1d7368-046d-4606-9492-2269e71d0837",
    lyrics: ["(chorus)",
"These are ordinal numbers, ordinal numbers,",
"so I can put things in order.",
"These are ordinal numbers, ordinal numbers,",
"so I can put things in order.",
"(verse)",
"First, f-i-r-s-t,",
"first, 1st.",
"Second, s-e-c-o-n-d,",
"second, 2nd.",
"Third, t-h-i-r-d,",
"third, 3rd.",
"Fourth, f-o-u-r-t-h,",
"fourth, 4th.",
"Fifth, f-i-f-t-h,",
"fifth, 5th.",
"Sixth, s-i-x-t-h,",
"sixth, 6th.",
"(chorus)",
"These are ordinal numbers, ordinal numbers,",
"so I can put things in order.",
"These are ordinal numbers, ordinal numbers,",
"so I can put things in order.",
"(verse 2)",
"Seventh, s-e-v-e-n-t-h,",
"seventh, 7th.",
"Eighth, e-i-g-h-t-h,",
"eighth, 8th.",
"Ninth, n-i-n-t-h,",
"ninth, 9th.",
"Tenth, t-e-n-t-h,",
"tenth, 10th.",
"Eleventh, e-l-e-v-e-n-t-h,",
"eleventh, 11th.",
"Twelfth, t-w-e-l-f-t-h,",
"twelfth, 12th.",
"(chorus)",
"These are ordinal numbers, ordinal numbers,",
"so I can put things in order.",
"These are ordinal numbers, ordinal numbers,",
"so I can put things in order.",
"© Smart Board Learning, LLC. All rights reserved."]
  },
  {
    title: "Dollars & Cents",
    slug: "dollarsandcents",
    standardNumber: "2.7",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdollarsandcents2025video.mp4?alt=media&token=8454884b-b9ba-441b-9134-ca432c7319a0",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdollarsandcents2025song.mp3?alt=media&token=97c2923e-18ea-41d1-8e22-8407ff969cc6",
    lyrics: ["(Chorus)",
"Make dollars, make cents.",
"Make dollars, make cents.",
"Let’s make dollars, make cents.",
"Let’s make dollars, make cents.",

"(Verse)",
"One penny is 1 cent, one penny is 1 cent.",
"The face on the front is Abraham Lincoln.",
"He was our 16th president.",
"One nickel is 5 cents, one nickel is 5 cents.",
"The face on the front is Thomas Jefferson.",
"He was our 3rd president.",
"One dime is 10 cents, one dime is 10 cents.",
"The face on the front is Franklin Roosevelt.",
"He was our 32nd president.",
"One quarter is 25 five cents, one quarter is 25 five cents.",
"The face on the front is George Washington.",
"He was our 1st president.",

"(Chorus)",
"Make dollars, make cents.",
"Make dollars, make cents.",
"Let’s make dollars, make cents.",
"Let’s make dollars, make cents.",

"(Verse)",
"Now, one penny is 1 cent, so 100 pennies is one dollar.",
"One nickel is 5 cents, so 20 nickels is one dollar.",
"One dime is 10 cents, so 10 dimes is one dollar.",
"One quarter is 25 cents, so 4 quarters is one dollar.",

"(Chorus)",
"Make dollars, make cents.",
"Make dollars, make cents.",
"Lets make dollars, make cents.",
"Lets make dollars, make cents.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "English Ruler",
    slug: "englishruler",
    standardNumber: "2.8",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenglishruler2025video.mp4?alt=media&token=3dde94f0-96e9-49ce-ab1e-f6133d4475f9",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenglishruler2025song.mp3?alt=media&token=2d1beb16-9520-4248-aa70-a8c1859e10c4",
    lyrics: ["(chorus)",
"Let's make it measure up, let's make it measure, yeah,",
"twelve inches makes one foot, yes it measures up, yeah.",
"Let's make it measure up, let's make it measure, yeah,",
"twelve inches makes one foot, yes it measures up, yeah.",
"(verse)",
"Look on a ruler, you will see numbers,",
"each number represents an inch, an inch.",
"Now each number tells how many inches,",
"you measure from beginning to end.",
"(chorus)",
"Let's make it measure up, let's make it measure, yeah,",
"twelve inches makes one foot, yes it measures up, yeah.",
"Let's make it measure up, let's make it measure, yeah,",
"twelve inches makes one foot, yes it measures up, yeah.",
"(verse)",
"Look on a ruler, you will see notches,",
"each notch is a different size, size.",
"The one in the middle, one half (1/2),",
"the next little, one fourth (1/4).",
"The next little, one eighth (1/8),",
"and the smallest notch is one sixteenth (1/16).",
"© Smart Board Learning, LLC. All rights reserved."]
  },
  {
    title: "Telling time",
    slug: "tellingtime",
    standardNumber: "2.9",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftellingtime2025video.mp4?alt=media&token=9d27ffc5-5101-4905-821e-bf1d47cdbaeb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftellingtime2025song.mp3?alt=media&token=117307c5-e509-4003-a294-7cbb49f997d4",
    lyrics: ["(chorus)",
"We can tell time, tell time, tell time.",
"We can tell time, tell time, tell time.",

"(verse)",
"Now, all clocks are broken down",
"into minutes and hours.",
"The little hand is the hour,",
"it tells us what the hour is.",
"When the little hand hits one, it’s 1 o’clock.",
"When the little hand hits two, it’s 2 o’clock.",
"When the little hand hits three, it’s 3 o’clock.",
"When the little hand hits four, it’s 4 o’clock.",

"Now, the big hand tells us the minutes.",
"Each notch is one minute.",
"Each number is five minutes.",
"When the big hand hits one, that’s 5 minutes.",
"When the big hand hits two, that’s 10 minutes.",
"When the big hand hits three, that’s 15 minutes.",
"When the big hand hits four, that’s 20 minutes.",

"(chorus)",
"We can tell time, tell time, tell time.",
"We can tell time, tell time, tell time.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Shapes",
    slug: "shapes",
    standardNumber: "2.13",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fshapes2025video.mp4?alt=media&token=d30cea74-886b-46e5-93ee-4b24a068576b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fshapes2025song.mp3?alt=media&token=3bb352c7-b9a4-46f3-91ad-f79f638945f9",
    lyrics: ["(chorus)",
"These are my shapes.",
"These are my shapes.",
"These are my shapes.",
"How many sides do they have?",

"(verse)",
"A triangle has 3 sides.",
"A rectangle has 4 sides.",
"A square has 4 sides.",
"A pentagon has 5 sides.",
"A hexagon has 6 sides.",
"An octagon has 8 sides.",

"(chorus)",
"These are my shapes.",
"These are my shapes.",
"These are my shapes.",
"How many sides do they have?",

"(verse)",
"A triangle has 3 sides.",
"A rectangle has 4 sides.",
"A square has 4 sides.",
"A pentagon has 5 sides.",
"A hexagon has 6 sides.",
"An octagon has 8 sides.",

"(chorus)",
"These are my shapes.",
"These are my shapes.",
"These are my shapes.",
"How many sides do they have?",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Quadrilaterals",
    slug: "quadrilaterals",
    standardNumber: "2.13",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fquadrilaterals2025video.mp4?alt=media&token=57b6de94-4476-44aa-ab80-267919f7223b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fquarilaterals2025song.mp3?alt=media&token=a6699325-e75b-45d0-96c5-9cd7855e1d32",
    lyrics: ["(chorus)",
"Quadrilaterals are four sided shapes, four sides,",
"quadrilaterals are four sided shapes, four sides.",
"(verse)",
"A quadrilateral is a four sided polygon.",
"A rectangle is a four sided quadrilateral,",
"with four right angles.",
"A rectangle is a four sided quadrilateral,",
"opposite sides are equal.",
"A square is a four sided quadrilateral,",
"all four sides are equal.",
"A parallelogram is a four sided quadrilateral,",
"with two pair of parallel sides.",
"(chorus)",
"Quadrilaterals are four sided shapes, four sides,",
"quadrilaterals are four sided shapes, four sides.",

"© Smart Board Learning, LLC. All rights reserved.",]
  },
  {
    title: "Pictograph",
    slug: "pictograph",
    standardNumber: "2.15",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpictograph.mp4?alt=media&token=33c8d3c8-ae82-4842-8ba4-f0139fbd9b3b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpictographsong.mp3?alt=media&token=8d7c80ac-0c89-4d5e-9623-700f31f3e14f",
    lyrics: ["(chorus)",
"A pictograph uses pictures,",
"a pictograph uses symbols.",
"Each picture or symbol is an amount of data.",
"A pictograph uses pictures,",
"a pictograph uses symbols.",
"Each picture or symbol is an amount of data.",
"(verse)",
"Each picture or symbol is called the key,",
"each picture or symbol is called the key.",
"A pictograph is fun to use, easy to read,",
"a pictograph is fun to use, easy to read.",
"(chorus)",
"A pictograph uses pictures,",
"a pictograph uses symbols.",
"Each picture or symbol is an amount of data.",
"A pictograph uses pictures,",
"a pictograph uses symbols.",
"Each picture or symbol is an amount of data.",

"© Smart Board Learning, LLC. All rights reserved.",]
  }
  
];
export default topics;